export const Gilson = () => {
  return (
    <section
      id="gilson"
      data-testid="gilson-section"
      className="bg-[#0a0a0a] text-white py-28 md:py-40 relative overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-6 reveal">
            <div className="img-zoom relative aspect-[4/5] bg-[#0a0a0a]">
              <img
                src="https://customer-assets.emergentagent.com/job_oasys-academy/artifacts/zdx0uw1p_Sem%20t%C3%ADtulo%20-%2005%20de%20julho%20de%202026%20%C3%A0s%2016.27.14-4%20%284%29.png"
                alt="Gilson Ribeiro, fundador da Oasys Academy, apoiado sobre livros"
                className="w-full h-full object-cover object-[center_20%]"
                style={{ filter: "contrast(1.05) brightness(1.02)" }}
              />
              <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(ellipse_at_center,transparent_60%,rgba(0,0,0,0.35)_100%)]" />
            </div>
          </div>

          <div className="lg:col-span-6 reveal">
            <div className="flex items-center gap-4 mb-8">
              <span className="rule-yellow" />
              <span className="eyebrow text-white/60">O fundador</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-[3.6rem] leading-[1.06] tracking-tight">
              Fundador técnico.
              <br />
              <em className="italic text-[#f4c542]">Educador estratégico.</em>
            </h2>

            <div className="mt-10 space-y-6 text-[1.05rem] md:text-lg leading-relaxed text-white/80 max-w-xl">
              <p>
                Gilson Ribeiro é cabeleireiro, fundador do Oasys Hair e
                criador da Oasys Academy. Há mais de duas décadas no
                mercado da beleza, transforma vivência real em método e
                leitura de mercado em direção.
              </p>
              <p>
                Sua educação parte da prática: do salão para a sala de
                aula, do atendimento para o repertório, da observação
                para a tese. Forma profissionais com presença, técnica e
                capacidade de decidir.
              </p>
            </div>

            <div className="mt-12 grid grid-cols-3 gap-6 max-w-lg">
              <div className="border-t border-white/15 pt-4">
                <p className="font-display text-3xl text-[#f4c542]">20+</p>
                <p className="eyebrow text-white/50 mt-2">Anos no setor</p>
              </div>
              <div className="border-t border-white/15 pt-4">
                <p className="font-display text-3xl text-[#f4c542]">01</p>
                <p className="eyebrow text-white/50 mt-2">Metodologia MACD</p>
              </div>
              <div className="border-t border-white/15 pt-4">
                <p className="font-display text-3xl text-[#f4c542]">∞</p>
                <p className="eyebrow text-white/50 mt-2">
                  Profissionais formados
                </p>
              </div>
            </div>

            <blockquote className="mt-14 font-display italic text-2xl md:text-[1.75rem] leading-snug text-white pl-6 border-l-2 border-[#f4c542] max-w-xl">
              &ldquo;O profissional não precisa de mais palco. Precisa de mais
              leitura, mais método e mais direção.&rdquo;
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  );
};
